'use strict';

export default function FormError({error, className = "error-mess"})
{
    if (error)
        return <div className={className}>{error}</div>
    
    return null;
}